"use client";
import React, { useCallback } from "react";
import { useTranslation } from "@/src/i18n/client";
import { productDetailsStore } from "@/store/pageModules";
import { FmButton } from "@/ui-component";
import variable from "@/src/styles/variables.module.scss";
import stl from "./productImgSwiper.module.scss";

export interface Props {
    video: string;
}

const ShowChangeVideoImgButton: React.FC<Props> = (props) => {
    const { video } = props;
    const [
        imgNum,
        videoAndSizeImgNum,
        videoIndex,
        swiperIndex,
        onChangeSwiperIndex,
    ] = productDetailsStore.useProdcutDetailsStore((state) => [
        state.imgNum,
        state.videoAndSizeImgNum,
        state.videoIndex,
        state.swiperIndex,
        state.onChangeSwiperIndex,
    ]);

    const { t } = useTranslation("productDetail");

    const goToProductImg = useCallback(() => {
        onChangeSwiperIndex(0);
    }, [onChangeSwiperIndex]);

    const goToVideo = useCallback(() => {
        video && onChangeSwiperIndex(videoIndex);
    }, [onChangeSwiperIndex, video, videoIndex]);

    return (
        <>
            {/* 没有视频的时候不显示切换控件 */}
            {video ? (
                <FmButton
                    onClick={() => {
                        swiperIndex < videoIndex
                            ? goToVideo()
                            : goToProductImg();
                    }}
                    size={"small"}
                    variant={"outlined"}
                    buttonColor={variable.text}
                    className={stl["video-button"]}
                >
                    {swiperIndex < videoIndex
                        ? t("productDetail:ViewVideo")
                        : t("productDetail:ViewImage")}
                </FmButton>
            ) : (
                <></>
            )}

            <div className={stl["current-index"]}>
                {/* 没有视频的时候，标注定位改为相对定位，不另占一行 */}
                {`${swiperIndex + 1}/${videoAndSizeImgNum + imgNum}`}
            </div>
        </>
    );
};

export default ShowChangeVideoImgButton;
